export const formatINR = (value: number | string | null | undefined): string => {
  if (value == null) return "—";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "—";
  return `₹ ${num.toLocaleString("en-IN")}`;
};

export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return "—";
  return new Date(date as string).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
